module.exports = __webpack_public_path__ + "static/media/Tricia Rathermel Headshot.66e43499.jpeg";